import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Grid, Paper, useMediaQuery, useTheme } from "@mui/material";
import { Skeleton } from "@mui/material";
import Stack from "@mui/material/Stack";
import { LocationPageWrapper } from "../Shared/components/PageWrapper/LocationPageWrapper";
const PostalCodeSkeleton = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"), { noSsr: true });
    return (_jsxs(Paper, Object.assign({ style: {
            display: "flex",
            flexDirection: "column",
            paddingTop: theme.spacing(5),
            paddingBottom: theme.spacing(5),
            paddingLeft: theme.spacing(6),
            paddingRight: theme.spacing(6),
            rowGap: theme.spacing(3),
        } }, { children: [_jsxs(Stack, Object.assign({ display: "flex", justifyContent: isMobile ? "space-between" : "center", flexDirection: "row", alignItems: "center" }, { children: [_jsx(Skeleton, { variant: "text", width: "50%" }), isMobile && _jsx(Skeleton, { variant: "circular", height: "20px", width: "20px" })] })), _jsx(Skeleton, { variant: "text", width: "100%" }), _jsx(Skeleton, { variant: "rectangular", width: "100%", height: "60px" }), !isMobile && _jsx(Skeleton, { variant: "rectangular", width: "100%", height: "85px" })] })));
};
const LocationCardSkeleton = () => {
    return (_jsx(Grid, Object.assign({ item: true, xx: 12, sm: 6 }, { children: _jsx(Skeleton, { variant: "rectangular", height: "110px" }) })));
};
const LocationCardLoadingSkeleton = () => {
    return (_jsxs(Grid, Object.assign({ container: true, spacing: 2 }, { children: [_jsx(LocationCardSkeleton, {}), _jsx(LocationCardSkeleton, {}), _jsx(LocationCardSkeleton, {}), _jsx(LocationCardSkeleton, {})] })));
};
const PickupSkeleton = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"), { noSsr: true });
    return (_jsxs(Paper, Object.assign({ style: {
            display: "flex",
            flexDirection: "column",
            padding: theme.spacing(3),
            rowGap: theme.spacing(3),
        } }, { children: [_jsxs(Stack, Object.assign({ display: "flex", justifyContent: isMobile ? "space-between" : "center", flexDirection: "row", alignItems: "center" }, { children: [_jsx(Skeleton, { variant: "text", width: "50%" }), isMobile && _jsx(Skeleton, { variant: "circular", height: "20px", width: "20px" })] })), _jsx(Skeleton, { variant: "text", width: "100%" }), _jsx(LocationCardLoadingSkeleton, {}), !isMobile && _jsx(Skeleton, { variant: "rectangular", width: "100%", height: "85px" })] })));
};
export const LocationSkeleton = () => {
    return (_jsx(LocationPageWrapper, Object.assign({ id: "location-page-skeleton" }, { children: _jsxs(Stack, Object.assign({ spacing: 3 }, { children: [_jsx(Box, Object.assign({ display: "flex", justifyContent: "center", alignItems: "center" }, { children: _jsx(Skeleton, { variant: "text", width: "75%" }) })), _jsx(PostalCodeSkeleton, {}), _jsx(PickupSkeleton, {})] })) })));
};
